export default __webpack_public_path__ + "static/media/151-lover.b28a3206.png";